import { gql } from '@apollo/client'

export const UPDATE_PARCEL = gql`
  mutation UPDATE_PARCEL($parcel: ParcelInput!) {
    updateParcel(parcel: $parcel) {
      success
    }
  }
`
